import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sba-message-dialog',
  templateUrl: './markdown-message-dialog.component.html',
  styleUrls: ['./markdown-message-dialog.component.scss']
})
export class MarkdownMessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MarkdownMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ok() {
    this.dialogRef.close(true);
  }
}
